import { config } from '../config';

export const baseMaps = {
  version: 8,
  glyphs: `https://api.maptiler.com/fonts/{fontstack}/{range}.pbf?key=${config.token.MAPTILER_KEY}`,
  sources: {
    'osm-tiles': {
      type: 'raster',
      tiles: [
        `https://api.maptiler.com/maps/streets-v2/256/{z}/{x}/{y}.png?key=${config.token.MAPTILER_KEY}`,
      ],
      tileSize: 256,
      maxzoom: 19,
      attribution:
        '© <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    },
    'ortho-tiles': {
      type: 'raster',
      tiles: [
        `https://api.maptiler.com/maps/satellite/{z}/{x}/{y}.png?key=${config.token.MAPTILER_KEY}`,
      ],
      tileSize: 256,
      maxzoom: 19,
      attribution:
        '© <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    },
  },
  layers: [
    {
      id: 'osm-tiles',
      type: 'raster',
      source: 'osm-tiles',
      interactive: true,
    },
    {
      id: 'ortho-tiles',
      type: 'raster',
      source: 'ortho-tiles',
      interactive: true,
      layout: {
        // Make the layer not visible by default.
        visibility: 'none',
      },
    },
  ],
};
